<template>
  <div class="langPosition">
    <button
        href="#"
        class="flex items-center langDropdownButton"
        @click="toggleVisibility"
        @keydown.space.exact.prevent="toggleVisibility"
        @keydown.esc.exact="hideDropdown"
        @keydown.shift.tab="hideDropdown"
        @keydown.up.exact.prevent="startArrowKeys"
        @keydown.down.exact.prevent="startArrowKeys"
    >
      <img :src="getFlag($i18n.locale)" alt="flag" class="flagShadow"/>
    </button>
    <transition name="dropdown-fade">
      <ul
          v-if="isVisible"
          ref="dropdown"
          v-on-clickaway="hideDropdown"
          class="langBox"
      >
        <li v-for="(lang, idx) in langs" :key="idx">
          <a
              href="#"
              class="flex langHover"
              @click.prevent="setLocale(lang.shortName, true)"
              @keydown.up.exact.prevent
              @keydown.tab.exact="focusNext(false)"
              @keydown.down.exact.prevent="focusNext(true)"
              @keydown.esc.exact="hideDropdown"
          >
            <img :src="getFlag(lang.flag)" :alt="lang.longName" class="flag"/>
            <span class="localLang">{{ lang.localName }}</span>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import flagMixin from '../mixins/flag'
import metaMixin from '../mixins/meta'
import {mixin as clickaway} from 'vue-clickaway'

export default {
  name: 'LanguageSwitcher',
  mixins: [flagMixin, clickaway, metaMixin],
  data()
  {
    return {
      isVisible: false,
      focusedIndex: 0,
      langs: [
        {
          shortName: 'gb',
          longName: 'English',
          localName: 'English',
          flag: 'gb'
        },
        {
          shortName: 'ee',
          longName: 'Estonian',
          localName: 'Estonian',
          flag: 'ee'
        },
        {
          shortName: 'de',
          longName: 'German',
          localName: 'German',
          flag: 'de'
        },
        {
          shortName: 'es',
          longName: 'Spanish',
          localName: 'Spanish',
          flag: 'es'
        }
        /*
        {
          shortName: 'it',
          longName: 'Italian',
          localName: 'Italian',
          flag: 'it'
        },
        {
          shortName: 'fr',
          longName: 'French',
          localName: 'French',
          flag: 'fr'
        } */
      ]
    }
  },
  methods: {
    toggleVisibility()
    {
      this.isVisible = !this.isVisible
    },
    hideDropdown()
    {
      this.isVisible = false
      this.focusedIndex = 0
    },
    startArrowKeys()
    {
      if (this.isVisible)
      {
        this.$refs.dropdown.children[0].children[0].focus()
      }
    },
    focusPrevious(isArrowKey)
    {
      this.focusedIndex = this.focusedIndex - 1
      if (isArrowKey)
      {
        this.focusItem()
      }
    },
    focusNext(isArrowKey)
    {
      this.focusedIndex = this.focusedIndex + 1
      if (isArrowKey)
      {
        this.focusItem()
      }
    },
    focusItem()
    {
      this.$refs.dropdown.children[this.focusedIndex].children[0].focus()
    },
    setLocale(locale, refresh = false)
    {
      this.$i18n.locale = locale
      localStorage.setItem('lang', locale)

      // this.$root.$emit('translationRun', locale)

      // Get lang code https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
      let lang = 'en' // by default
      switch (locale)
      {
        case 'ee':
          lang = 'et'
        break
        case 'de':
          lang = 'de'
        break
        case 'es':
          lang = 'es'
        break
      }
      document.documentElement.lang = lang

      // Uncomment the below lines if you need language prefixes to be shown in the URL
      // example: en.website.com (additional router configuration required)

      // this.$router.push({
      //   params: { lang: locale }
      // })
      this.hideDropdown()
      if (refresh) {
        const originPath = window.location.origin
        if (this.$route && this.$route.meta && this.$route.meta.key) {
          if (lang === 'en') {
            location.href = originPath + '/' + this.$t('router.links.' + this.$route.meta.key, this.$i18n.locale)
          } else {
            location.href = originPath + '/' + lang + '/' + this.$t('router.links.' + this.$route.meta.key, this.$i18n.locale)
          }
        } else {
          if (this.$route && this.$route.name && this.$route.name === 'Home')
          {
            // only for home page
            if (lang === 'en') {
              location.href = originPath + '/'
            } else {
              location.href = originPath + '/' + lang + '/'
            }
          } else {
            location.reload()
          }
        }
      }

      // this.updateAlternate()
    }
  }
}
</script>

<style lang="scss" scoped>
// Position of language dot
.langPosition {
  display: flex;
  justify-content: center;
}

// Box that holds all language options
.langBox {
  user-select: none;
  padding: 5px 5px 5px -5px;
  width: max-content;
  box-shadow: 0px 3px 6px rgb(204, 210, 235);
}

// Language name text
.localLang {
  position: absolute;
  margin-top: 3px;
  font-size: 18px;
  padding-left: 15px;
  font-weight: 400;
  vertical-align: middle;
}

// Animations
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.1s ease-in-out;
}

.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

.langDropdownButton {
  outline: none;
  cursor: pointer !important;
  background-color: transparent !important;
  border: none;
  padding-right: 0px;
}

.shortName {
  margin-top: 5px !important;
}

ul {
  text-align: left;
  min-width: 155px;
  border-radius: 8px;
  background: var(--black);
  z-index: 500;
  position: absolute;
  list-style: none;
  padding: 10px 10px !important;
  margin-top: 30px;
  margin-right: 5px;
  right: 8%;

  li {
    padding: 5px 0;
  }
}

.flag {
  width: 30px;
}

.flagShadow {
  border-radius: 50px;
  box-shadow: 0px 3px 3px rgb(204, 210, 235);
  width: 35px;
}

.langHover {
  margin: 10px;
  text-decoration: none;
  color: #222;
  transition: all 0.1s ease-in-out;

  &:hover {
    color: #007aff;
  }
}
</style>
